import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full px-4 md:px-6 py-6"
}
const _hoisted_4 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined mr-1",
  style: {"font-size":"18px"}
}, " arrow_back ", -1)
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 xl:gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-5xl text-muted mb-2 group-hover:text-primary transition-colors" }, " add_circle_outline ", -1)
const _hoisted_9 = { class: "font-medium text-muted group-hover:text-primary transition-colors" }
const _hoisted_10 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
}
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col items-center py-16 opacity-40"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"6rem","opacity":"0.5"}
}, " fitness_center ", -1)
const _hoisted_13 = { class: "mt-2 text-center" }
const _hoisted_14 = { class: "mb-4 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_PublicEventParticipationPreview = _resolveComponent("PublicEventParticipationPreview")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!
  const _component_PracticeTemplateEditorNew = _resolveComponent("PracticeTemplateEditorNew")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.initialLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Spinner, {
            size: "xl",
            variant: "primary"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Btn, {
              variant: "secondary",
              size: "sm",
              onClick: _ctx.goBack
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("learning_journey.free_practice")), 1)
          ]),
          (!_ctx.firstLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewPracticeDialog && _ctx.openNewPracticeDialog(...args))),
                  class: "card card-border flex flex-col items-center justify-center cursor-pointer h-44 md:h-64 hover:border-primary hover:bg-primary hover:bg-opacity-5 transition-colors group"
                }, [
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("student_course_dashboard.new_practice")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceParticipations, (participation) => {
                  return (_openBlock(), _createBlock(_component_PublicEventParticipationPreview, {
                    key: 'practice-' + participation.id,
                    participation: participation,
                    "course-id": _ctx.courseId,
                    slug: _ctx.slug,
                    loading: _ctx.loadingParticipations.has(participation.id),
                    onBookmark: ($event: any) => (_ctx.onBookmark(participation))
                  }, null, 8, ["participation", "course-id", "slug", "loading", "onBookmark"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_SkeletonCard, { full: true }),
                _createVNode(_component_SkeletonCard, { full: true }),
                _createVNode(_component_SkeletonCard, { full: true }),
                _createVNode(_component_SkeletonCard, { full: true })
              ])),
          (!_ctx.firstLoading && _ctx.practiceParticipations.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("learning_journey.no_practices_yet")), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.firstLoading)
            ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
                key: 3,
                load: _ctx.onLoadMore,
                class: "mt-6",
                "is-initial": _ctx.isInitialInfiniteLoad,
                "onUpdate:is-initial": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_Spinner)
                ]),
                "no-more": _withCtx(() => [
                  _createTextVNode(" ")
                ]),
                _: 1
              }, 8, ["load", "is-initial"]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_Dialog, {
      onNo: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPracticeDialog = false)),
      onYes: _ctx.onBeginPractice,
      noText: _ctx.$t('dialog.default_cancel_text'),
      yesText: 
				_ctx.practiceDialogLoading
					? _ctx.$t('misc.wait')
					: _ctx.$t('practice_template_editor.begin_practice')
			,
      fullWidth: _ctx.hasTags,
      disableOk: 
				_ctx.practiceDialogLoading || _ctx.draftEventTemplate.rules.length === 0 || _ctx.isEditingRule
			,
      showDialog: _ctx.showPracticeDialog,
      loading: _ctx.practiceDialogLoading
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("student_course_dashboard.new_practice")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.hasTags
							? _ctx.$t("practice_template_editor.choose_tags_text")
							: _ctx.$t("practice_template_editor.choose_exercises_no_tag_text")), 1),
        _createVNode(_component_PracticeTemplateEditorNew, {
          modelValue: _ctx.draftEventTemplate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draftEventTemplate) = $event)),
          onIsEditing: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEditingRule = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["onYes", "noText", "yesText", "fullWidth", "disableOk", "showDialog", "loading"])
  ]))
}